// @flow

import styled from 'styled-components'
import { colors } from '@components/shared'
import { config } from 'react-awesome-styled-grid'

export const ModalHeader = styled.h1`
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 36px;
  color: ${colors.white};
  text-align: center;
  margin: 0 0 20px;
  width: 100%;
  ${(props: any): string => config(props).media.md`
    font-size: 40px;
    line-height: 44px;
  `}
`
export const ModalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${(props: any): string => config(props).media.md`
    margin: 64px;
    width: 100%;
  `}
`
export const ModalDescriptionWrapper = styled.div`
  margin: 0 0 48px;
  ${(props: any): string => config(props).media.md`
    margin: 0 0 56px;
  `}
`
export const ModalErrDescriptionWrapper = styled.div`
  margin: 0 0 20px;
  ${(props: any): string => config(props).media.md`
    margin: 0 0 32px;
  `}
`
export const ModalDescription = styled.p`
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: ${colors.white};
  padding:0 30px;
  margin: 0;
`
export const ButtonSpacer = styled.div`
  margin-bottom: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  ${(props: any): string => config(props).media.md`
    margin-bottom: 32px;
  `}
`
export const LoadingImg = styled.img`
  width: 32px;
  height: 32px;
  ${(props: any): string => config(props).media.md`
    width: 47.5px;
    height: 47.5px;
  `}
  
`
export const LoadingImgWrapper = styled.div`
  margin-bottom: 24px;
  ${(props: any): string => config(props).media.md`
    margin-bottom: 32px;
  `}
`

export const SubscriptionManagementContainer = styled.div`
  margin-top: 32px;
  ${(props: any): string => config(props).media.md`
    margin-top: 0;
  `}
`
export const SubscriptionManagementHeader = styled.h1`
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 43px;
  text-align:center;
  margin: 0 0 60px;
  padding: 0;
`
export const SubscriptionTextWrapper = styled.div`
  margin-bottom: 40px;
  ${(props: any): string => config(props).media.md`
    margin-bottom: 56px;
  `}
`
export const SubscriptionTextWrapperSplit = styled.div`
  margin-bottom: 30px;
  ${(props: any): string => config(props).media.md`
    align-items: baseline;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
  `}
`
export const ExternalLink = styled.a`
  cursor: pointer;
  padding: 8px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  text-align: right;
  align-items: center;
  opacity: 0.5;
  text-decoration: none;
  > * {
    text-align: right;
  }
`
export const TextA = styled.p`
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: ${colors.white};
  margin: 0;
  padding: 0 0 16px;
  ${(props: any): string => config(props).media.md`
    font-size: 28px;
    line-height: 32px;
    padding: 0 0 20px;
  `}
`
export const TextB = styled.p`
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${(props: any): any => props.color || colors.white};
  margin: 0;
  padding: 0 0 12px;
  display: flex;
  align-items: center;
  ${(props: any): string => config(props).media.md`
    font-size: 24px;
    line-height: 28px;
  `}
`
export const TextC = styled.p`
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: ${colors.sand60};
  margin: 0;
  padding: 0 0 12px;
  ${(props: any): string => config(props).media.md`
    font-size: 24px;
    line-height: 28px;
    padding: 0 0 0px;
  `}
`

export const TextD = styled.p`
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.secondaryBlue};
  margin: 0;
  padding: 0 0 4px;
  :hover {
    color: ${colors.white};
  }
  ${(props: any): string => config(props).media.md`
    font-size: 20px;
    line-height: 24px;
    padding: 0 0 0px;
  `}
`

export const ButtonWrapper = styled.div`
  margin-top: 10px;
  ${(props: any): string => config(props).media.md`
    margin-top: 20px;
  `}
`

export const TrialSpan = styled.span`
  background: ${colors.white};
  border-radius: 4px;
  margin-left: 16px;
  padding: 2px 6px;
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: black;
`
export const MaxWidthDiv = styled.div`
  max-width: 335px;
`

export const WarningTextP = styled.p`
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: normal;
  color: ${colors.peach};
  margin: 0;
  font-size: 20px;
  line-height: 24px;
  padding: 0 0 12px;
  ${(props: any): string => config(props).media.md`
    font-size: 24px;
    line-height: 28px;
    padding: 0;
  `}
`
export const GifDiv = styled.div`
  align-self: stretch;
`
export const PlainAnchor = styled.a`
  text-decoration: none;
`
